import { init } from 'redux-acron'
import LocaleModule from './LocaleModule'
import AuthModule from './AuthModule'
import AccountModule from './AccountModule'
import AppDataModule from './AppDataModule'
import IAAgentModule from '@components/IAAgent/IAAgentModule'

const modules = init([
  LocaleModule,
  AuthModule,
  AccountModule,
  AppDataModule,
  IAAgentModule
])
//console.log('[Modules] Sagas cargadas:');
//console.log(modules)

export default modules
